<template>
  <div class="col-12 col-md-6 col-xl">
    <div class="checkout-product-box px-3 py-4">
      <div class="checkout-section-heading mx-n1">
        <ClientOnly><img src="@/esf_antarctica_lederhosenland/assets/imgs/cartpage-icon.svg" class="cartpage-icon" alt=""></ClientOnly>

        <h4 style="margin-left: 5px;">{{ $t("order_overview") }}</h4>
      </div>
      <h5 class="h3 my-4">{{ $t("items_in_cart", { numberOf: cartCount }) }}</h5>
      <div class="checkout-items mx-n3" style="background-color: #d9d9d9 ;">
        <div class="checkout-item" v-for="cartItem of cartItems" :key="cartItem.id">
          <div class="checkout-item-img-wrapper border border-secondary">
            <img class="img-fluid object-fit-contain" :src="cartItem.product.image.url" :alt="cartItem.product.name"
              width="215" height="180">
          </div>
          <div class="checkout-item-details p-3 d-grid">
            <h6 class="h5 mb-4">{{ cartItem.product.name }}</h6>
            <div class="checkout-item-details-qty mt-5">
              <div class="input-group mb-2">
                <button class="btn" type="button" @click="quantityDown(cartItem.id, cartItem.quantity)">-</button>
                <input type="text" min="1" class="form-control flex-grow-0" placeholder="Qty"
                  aria-label="Product Quantity" :value="cartItem.quantity" name="quantity" ref="inputQuantity" disabled>
                <button class="btn" type="button" @click="quantityUp(cartItem.id, cartItem.quantity)">+</button>
              </div>
              <b-link :to="`/${cartItem.product.url_key}`" class="checkout-item-details-link mb-2 text-decoration-none">
                {{ $t("details") }}
              </b-link>
            </div>
          </div>
        </div>
      </div>
      <div class="checkout-overview mt-5">
        <h6 class="h4 border-bottom border-black pb-3 mb-4">{{ $t("order_overview") }}</h6>
        <ClientOnly>
          <table class="table table-borderless fw-bold">
            <tr>
              <td>{{ $t("subtotal_btw") }}:</td>
              <td>{{ formatCurrency(cartSubTotalPrice) }}</td>
            </tr>
            <tr v-for="(price, index) in cartTotalDiscounts" :key="`price-${index}`">
              <td>{{ price.label }}:</td>
              <td>- {{ formatCurrency(price.amount.value) }}</td>
            </tr>
            <tr>
              <td v-if="shippingMethod != null">{{ shippingMethod.carrier_title }} / {{ shippingMethod.method_title }}:
              </td>
              <td v-if="shippingMethod != null">{{ formatCurrency(shippingMethod.amount_including_tax.value) }}</td>
            </tr>
            <tr v-for="(price, index) in cartTotalTaxPrices" :key="`tax-${index}`">
              <td>{{ price.label }}:</td>
              <td>{{ formatCurrency(price.amount.value) }}</td>
            </tr>
            <tr class="total-row">
              <td>{{ $t("total_btw") }}:</td>
              <td class="text-primary total-raw-price">{{ formatCurrency(cartTotalPrice) }}</td>
            </tr>
          </table>
        </ClientOnly>
        <div class="checkout-discount my-4">
          <h6 class="mb-3">{{ $t("coupon_discount") }}:</h6>
          <div class="input-group bg-white mb-3">
            <input v-model="couponCode" type="text" class="form-control" :placeholder="$t('fill_out_discount_code')"
              aria-label="Coupon Code" aria-describedby="checkout-coupon">
            <button class="btn btn-outline-primary px-4" type="button" id="checkout-coupon" @click="addCoupon">{{
              $t("add") }}</button>
          </div>
        </div>
        <div class="form-check form-check-flat mb-4 ps-5">
          <input class="form-check-input" type="checkbox" id="newsletter" v-model="SubscribeNewsletter"
            name="news-letter-subscribe" value="yes" unchecked-value="no">
          <label class="form-check-label" for="newsletter">{{ $t("subscription_newsletter") }}</label>
        </div>
        <p>
          {{ this.$t('checkout_agree_label') }}
          <b-link to="/algemene-voorwaarden">{{ this.$t("ALGEMENE VOORWAARDEN") }}</b-link>
          {{ this.$t("en") }}
          <b-link to="/privacy-beleid"> {{ this.$t("PRIVACY VERKLARING") }} </b-link>
        </p>
      </div>
      <button class="btn checkout-btn btn-primary text-uppercase w-100" type="button" @click="submitForm"
        v-bind:disabled="buttonClicked">{{ $t("pay") }}</button>
    </div>
  </div>
</template>

<script>
import ClientOnly from "vue-client-only";
import config from "@config";
import Cart from "@storefront/core/modules/cart/mixins";

export default {
  name: "CheckoutOverview",
  components: {
    ClientOnly,
  },
  mixins: [Cart],
  data: () => ({
    couponCode: "",
    customerNote: "",
    SubscribeNewsletter: "no",
    buttonClicked: false,
    localStorageData: {},
  }),
  computed: {
    isLoggedIn() {
      return this.$store.getters["user/getIsLoggedIn"];
    },
    isCreateAccount() {
      return this.$store.getters["checkout/getCreateAccount"];
    },
    shippingMethod() {
      return this.$store.getters["cart/getShippingMethod"];
    },
    btnDisable() {
      if (this.$store.getters["cart/getShippingAddress"] == null) {
        return true;
      }
      if (this.$store.getters["cart/getBillingAddress"] == null) {
        return true;
      }
      if (this.$store.getters["cart/getShippingMethod"] == null) {
        return true;
      }
      if (this.$store.getters["cart/getPaymentMethod"] == null) {
        return true;
      }
      if (this.$store.getters["cart/getEmail"] == null) {
        return true;
      }
      if (this.$store.getters["cart/getItemsTotalQuantity"] == 0) {
        return true;
      }
      return false;
    },
    cartTotalWithOutTax: function () {
      if (this.$store.getters["cart/getCartIsLoaded"] == true) {
        const prices = this.$store.getters["cart/getCartPrices"];
        if (typeof prices != "undefined") {
          if (typeof prices.subtotal_excluding_tax != "undefined") {
            if (typeof prices.subtotal_excluding_tax.value != "undefined") {
              return prices.subtotal_excluding_tax.value;
            }
          }
        }
        return 0;
      } else {
        return 0;
      }
    },
    cartSubTotal() {
      if (this.$store.getters["cart/getCartIsLoaded"] == true) {
        const prices = this.$store.getters["cart/getCartPrices"];
        if (typeof prices != "undefined") {
          if (typeof prices.subtotal_including_tax != "undefined") {
            if (typeof prices.subtotal_including_tax.value != "undefined") {
              return prices.subtotal_including_tax.value;
            }
          }
        }
        return 0;
      } else {
        return 0;
      }
    },
    totalCartTax: function () {
      if (this.$store.getters["cart/getCartIsLoaded"] == true) {
        const prices = this.$store.getters["cart/getCartPrices"];
        let totalTax = { value: 0 };
        if (
          typeof prices != "undefined" &&
          typeof prices.applied_taxes == "object"
        ) {
          prices.applied_taxes.forEach(function (amount) {
            totalTax.value += amount.amount.value;
          });
        }
        return [{ amount: totalTax, label: this.$t("VAT") }];
      }
      //return [{ amount: {'value':0}, label: this.$t("VAT") }];
      return this.cartTotalTaxPrices;
    },
  },
  mounted() {
    const bcrumb = { current: this.$t("checkout"), routes: [] };
    this.$store.commit("breadcrumbs/set", bcrumb);
    if (this.$gtm.enabled()) {
      let prod = [];
      let items = [];
      this.cartItems.forEach((element) => {
        let i = {
          id: element.product.sku,
          name: element.product.name,
          quantity: element.quantity,
        };
        prod.push(i);
      });
      this.cartItems.forEach((element) => {
        let i = {
          item_id: element.product.sku,
          item_name: element.product.name,
          quantity: element.quantity,
          currency: "EUR",
          price: element.prices.price.value,
        };
        items.push(i);
      });
      if (!this.$gtm.uaDisabled) {
        //GA event
        window.dataLayer.push({
          event: "eec.checkout",
          ecommerce: {
            checkout: {
              actionField: {
                step: 1,
                option: "",
                action: "checkout",
              },
              products: prod,
            },
          },
        });
      }
      if (this.$gtm.ga4Enabled) {
        //GA4 event
        window.dataLayer.push({
          event: "begin_checkout",
          ecommerce: {
            add: {
              currency: "EUR",
              value: this.cartTotalWithOutTax,
              items: items,
            },
          },
        });
      }
    }
    this.storage();
  },
  methods: {
    formatCurrency(value) {
      var formatter = new Intl.NumberFormat("nl-NL", {
        style: "currency",
        currency: "EUR",
      });
      return formatter.format(value);
    },
    removeCartItem(id) {
      const cartItems = this.cartItems.filter((v) => v.id != id);
      if (cartItems.length === 0) {
        this.removeItem(id);
        this.$router.push("/checkout/cart");
      } else {
        this.removeItem(id);
      }
    },
    async addCoupon() {
      if (this.couponCode != "") {
        const retval = await this.$store.dispatch("cart/addCouponCode", {
          code: this.couponCode,
        });
        if (retval == true) {
          const msg = {
            type: "success",
            title: this.$t("coupon_code"),
            text: this.$t("coupon_code_ok", { code: this.couponCode }),
          };
          this.$store.dispatch("messages/sendMessage", { message: msg });
          this.couponCode = "";
        }
      }
    },
    async addRemark() {
      if (this.customerNote != "") {
        this.$store.commit("cart/setComment", this.customerNote);
      }
    },
    async submitForm() {
      this.buttonClicked = true;
      this.checkSiblingFields();
      if (this.checkFields()) {
        this.buttonClicked = true;
        if (this.selectedPaymentMethod == "multisafepay_ideal") {
          this.$store.commit("cart/updateCartPaymentMethodOptions", {
            key: this.selectedPaymentMethod,
            sub: "issuer_id",
            value: this.selectedIssuer,
          });
        }
        const retval = await this.$store.dispatch("cart/addPaymentMethod");
        if (retval != false) {
          localStorage.removeItem("orderHash");
          if (retval.order.hash) {
            localStorage.setItem("orderHash", retval.order.hash);
          }

          const url = retval.redirect_url.replace(config.app_url, "");
          if (this.isLoggedIn == true) {
            this.$store.dispatch("user/loadOrders", { page: 1, perPage: 10 });
          } else {
            // Create Account
            if (this.isCreateAccount == true) {
              this.$store.dispatch("checkout/changeCreateAccount", false);
              this.$store.commit("cart/setShippingAddress", null);

              this.createAccount();
            }
          }
          if (url.includes("https://")) {
            window.location = url;
          } else {
            this.$store.dispatch("cart/loadCart");
            this.$router.push({
              path: url + "?transactionid=" + retval.order.increment_id,
              params: { hash: retval.order.hash },
            });
          }
        }
      }
      this.buttonClicked = false; //Re-enable button when addPaymentMethod fails
    },
    storage() {
      this.localStorageData =
        JSON.parse(localStorage.getItem("checkoutOverview")) ?? {};
      this.localStorageData.delivery
        ? ((this.pickupLocation = this.localStorageData.delivery),
          (this.showPickupLocation = true),
          (this.selectedPickupLocation = this.localStorageData.delivery))
        : "";
      this.localStorageData.billing
        ? (this.selectedPaymentMethod = this.localStorageData.billing)
        : null;
      this.localStorageData.issuer
        ? ((this.selectedIssuer = this.localStorageData.issuer),
          (this.isPaymentSelected = true),
          (this.showPaymentSuboptions = "collapse show"),
          this.setPaymentMethodOptions(
            this.localStorageData.billing,
            "issuer_id",
            this.localStorageData.issuer
          ))
        : null;
      this.localStorageData.newsletter
        ? (this.SubscribeNewsletter = this.localStorageData.newsletter)
        : (this.SubscribeNewsletter = "yes");
    },
    updateLocalStorage(data) {
      this.localStorageData = Object.assign({}, this.localStorageData, data);
      localStorage.setItem(
        "checkoutOverview",
        JSON.stringify(this.localStorageData)
      );
    },
    checkFields() {
      var errorFields = [];
      var storeValidation = this.$store.getters["cart/getStoreValidation"];
      for (const property in storeValidation) {
        storeValidation[property].forEach((error) => {
          if (error != "" && error != "Bank") {
            errorFields.push(this.$t(error));
          }
        });
      }
      if (errorFields.length > 0) {
        const msg = {
          type: "danger",
          title: this.$t("Checkout fields incomplete"),
          text: `${this.$t("The_followingfields_are_invalid:")} ${errorFields.join(", ")}`,

        };
        this.$store.dispatch("messages/sendMessage", { message: msg });
        return false;
      }
      return true;
    },
    checkSiblingFields() {
      this.$root.$emit("checkFields");
    },
  },
  watch: {
    SubscribeNewsletter() {
      this.updateLocalStorage({ newsletter: this.SubscribeNewsletter });
    },
  },
};
</script>

<style></style>
